import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { lang_help } from 'app/idiomas/i18n/ayuda/ayuda.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import * as backInter from 'app/auth/auth-data.model';
@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  productoCertificar: backInter.prodNorma35;

  constructor(
    private _formBuilder: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private colaboradoresService: Colaboradores35Service,
    ) {
      this.obtieneCertificarActual();
      lang_help.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
     }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }
  typeContent:any;
  obtieneCertificarActual(){

    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log("Data certifiar");
      console.log(data);
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
             // this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.typeContent=this.productoCertificar.tipo;

                 // CENTROS DE TRABAJO HIJOS
              // this.info=this.colaboradoresService.getinfo();
               // FIN CENTRO DE TRABAJO HIJO
              throw BreakException;
            }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  Seccion1 = [
 
    {
      pregunta  : "¿Qué es la NOM-035?",
      descripcion :[
        {
          'des':'-De acuerdo con la Secretaría del Trabajo y Previsión Social, la Norma Oficial Mexicana, NOM- 035- STPS- 2018 tiene como objetivo establecer los elementos para identificar, analizar y prevenir los factores de riesgo psicosocial, así como para promover un entorno organizacional favorable en los centros de trabajo.',
        },{
          'des':'-En sus anexos contiene información, especificaciones, procedimientos, instrumentos de medición y metodologías que deben cumplir todas las organizaciones y empresas en el país.'
        }
      ]
    },
    {
      pregunta  : "¿Cuál es el alcance de la NOM-035-STPS-2018?  ",
      descripcion :[
        {
          'des':'La NOM-035-STPS-2018, sólo comprende dos aspectos:'
        },{
          'des':'-El entorno organizacional favorable: Aquel en el que se promueve el sentido de pertenencia de los trabajadores a la empresa; la formación para la adecuada realización de las tareas encomendadas; la definición precisa de responsabilidades para los trabajadores del centro de trabajo; la participación proactiva y comunicación entre trabajadores; la distribución adecuada de cargas de trabajo, con jornadas de trabajo regulares conforme a la Ley Federal del Trabajo, y la evaluación y el reconocimiento del desempeño.'
        },{
          'des':'-Los factores de riesgo psicosocial: Aquellos que pueden provocar trastornos de ansiedad, no orgánicos del ciclo sueño-vigilia y de estrés grave y de adaptación, derivado de la naturaleza de las funciones del puesto de trabajo, el tipo de jornada de trabajo y la exposición a acontecimientos traumáticos severos o a actos de violencia laboral al trabajador, por el trabajo desarrollado. '
        },{
          'des':'Como puede apreciarse los factores de riesgo psicosocial y los elementos del entorno organizacional favorable derivan de la naturaleza del puesto, es decir, de las condiciones en las que se realizan las actividades, por lo que el análisis de estos elementos implica una evaluación de las condiciones en las que los trabajadores las desarrollan. '
        },{
          'des':'La identificación y análisis de los factores de riesgo psicosocial, así como la evaluación del entorno organizacional, no contemplan una evaluación psicológica de los trabajadores.'
        }
        
      ]
    },
    {
      pregunta  : "¿Qué factores se analizan y evalúan en NOM-035-STPS-2018? ",
      descripcion :[
        {
          'des':'Los factores de riesgo psicosocial que están contemplados en la norma son: '
        },{
          'des':'-Condiciones del ambiente de trabajo.'
        },{
          'des':'-Cargas de trabajo.'
        },{
          'des':'-Control sobre el trabajo.'
        },{
          'des':'-Jornadas que exceden lo establecido en la ley.'
        },{
          'des':'-Interferencia en la relación trabajo-familia.'
        },{
          'des':'-Liderazgo negativo y relaciones negativas.'
        },{
          'des':'-Violencia laboral.'
        }
      ]
    }
  ]

  Seccion2 = [
    {
      pregunta  : "¿Qué relación tiene la  NOM-035 con iniciativas y certificaciones como Great Place to Work,  Wellness, ESR, Programas de Salud y Bienestar y/o Mindfulness?",
      descripcion :[
        {
          'des':'Todos los esfuerzos que una organización haya realizado con: '
        },{
          'des':'-Liderazgo.'
        },{
          'des':'-Comunicación Efectiva.'
        },{
          'des':'-Organización del Trabajo.'
        },{
          'des':'-Programas de Integración.'
        },{
          'des':'-Modelos de Reconocimiento.'
        },{
          'des':'-Así como certificaciones referentes al entorno y clima laboral.'
        },{
          'des':'Pueden ser aprovechados, no obstante, dado que esta Norma es obligatoria e insustituible,  debe cumplirse utilizando su propia metodología.'
        }

      ]
    },{
      pregunta  : "¿Cúal es su campo de aplicación?",
      descripcion :[
        {
          'des':'La NOM-035-STPS-2018, rige en todo el territorio nacional y aplica en todos los centros de trabajo.'
        },{
          'des':'Sin embargo, las disposiciones de esta Norma aplican de acuerdo con el número de trabajadores que laboran en el centro de trabajo, existen tres categorías:'
        },{
          'des':'-Centros de trabajo donde laboran hasta 15 trabajadores.'
        },{
          'des':'-Centros de trabajo donde laboran entre 16 y 50 trabajadores, y'
        },{
          'des':'-Centros de trabajo donde laboran hasta más de 50 trabajadores.'
        }
      ]
    },{
      pregunta  : "¿Cuál es la línea de tiempo de aplicación idonea de los cuestionarios y encuesta?",
      descripcion :[
        {
          'des':'La Norma señala que los cuestionarios deben aplicarse al menos cada dos años.'
        },{
          'des':'Recomendamos:'
        },{
          'des':'-Iniciar con un mes de anticipación la invitación a participar en el ejercicio de contestar la encuesta.'
        },{
          'des':'-En este tiempo deberá trabajarse el listado de colaboradores y centros de trabajo por razón social.'
        },{
          'des':'-El tiempo de encuestamiento debe ser de tres semanas.'
        },{
          'des':'-Los resultados del ejercicio de la encuesta aparecerán en la plataforma 72 horas después de terminado este ejercicio.'
        },{
          'des': '-El seguimiento a las acciones y registros deberá ser continuo.'
        }
      ]
    },{
      pregunta  : "¿Qué registro necesito? ",
      descripcion :[
        {
          'des':'La Norma señala que los centros de trabajo deben contar con registros sobre: '
        },{
          'des':'-Los resultados de la identificación y análisis de los factores de riesgo psicosocial y, además, tratándose de centros de trabajo de más de 50 trabajadores, de las evaluaciones del entorno organizacional; '
        },{
          'des':'-Las medidas de control adoptadas cuando el resultado de la identificación y análisis de los factores de riesgo psicosocial y evaluación del entorno organizacional lo señale, y '
        },{
          'des':'-Los nombres de los trabajadores a los que se les practicaron los exámenes o evaluaciones clínicas y que se comprobó la exposición a factores de riesgo psicosocial, a actos de violencia laboral o acontecimientos traumáticos severos. '
        },{
          'des':'-El registro sobre de la identificación y análisis de los factores de riesgo psicosocial tratándose de centros de trabajo de más de 50 trabajadores, de las evaluaciones del entorno organizacional, los centros de trabajo siempre deberán contar con él, invariablemente. '
        },{
          'des':'El Registro de las medidas de control y de los trabajadores del centro de trabajo a los que se les aplicaron evaluaciones clínicas dependerá del resultado de identificación y análisis de los factores de riesgo psicosocial y, en su caso, de que los trabajadores manifiesten alguna alteración a su salud.'
        }
      ]
    },
  ]

  Seccion3 = [
 
     {
      pregunta  : "¿Cúando aplican las medidas y acciones del control?",
      descripcion :[
        {
          'des':'Es de destacar que las medidas de control deben ser determinadas para cada tipo de factor cuyo resultado sea de un nivel de riesgo medio, alto o muy alto, conforme a las características de las actividades del centro de trabajo, en ese sentido, la Norma no obliga a una medida específica, en realidad obliga a que los centros de trabajo establezcan acciones de control para los hallazgos encontrados en las evaluaciones.'
        },{
          'des':'El tipo de acciones deberán realizarse, según aplique, en los niveles siguientes: '
        },{
          'des':'-Primer nivel: Las acciones se centran en el plano organizacional e implican actuar sobre la política de prevención de riesgos psicosociales del centro de trabajo, la organización del trabajo, las acciones o medios para: disminuir los efectos de los factores de riesgo psicosocial, prevenir la violencia laboral y propiciar el entorno organizacional favorable. '
        },{
          'des':'-Segundo nivel: Las acciones se orientan al plano grupal e implica actuar en la interrelación de los trabajadores o grupos de ellos y la organización del trabajo; su actuación se centra en el tiempo de trabajo, el comportamiento y las interacciones personales, se basan en proporcionar información al trabajador, así como en la sensibilización, (contempla temas como: manejo de conflictos, trabajo en equipo, orientación a resultados, liderazgo, comunicación asertiva, administración del tiempo de trabajo, entre otros), y reforzar el apoyo social, y/o '
        },{
          'des':'-Tercer nivel: Las acciones se enfocan al plano individual; es decir, se desarrolla cuando se comprueba que existen signos y/o síntomas que denotan alteraciones en la salud, se incluyen intervenciones de tipo clínico o terapéutico. Las intervenciones de tercer nivel que sean de tipo clínico o terapéutico deberán ser realizadas invariablemente por un médico, psicólogo o psiquiatra según corresponda.'
        }
      ]
    }, {
      pregunta  : "¿Capacitación o información?",
      descripcion :[
        {
          'des':'La NOM-035-STPS-2018, en general no tiene como obligación del patrón que proporcione capacitación, en realidad la obligación genérica es difundir y proporcionar información a los trabajadores sobre: '
        },{
          'des':'-La política de prevención de riesgos psicosociales; '
        },{
          'des':'-Las medidas adoptadas para combatir las prácticas opuestas al entorno organizacional favorable y los actos de violencia laboral; '
        },{
          'des':'-Las medidas y acciones de prevención;'
        },{
          'des':'-Las acciones de control de los factores de riesgo psicosocial, en su caso (aplica para centros de trabajo de más de 15 trabajadores); '
        },{
          'des':'-Los mecanismos para presentar quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral; '
        },{
          'des':'-Los resultados de la identificación y análisis de los factores de riesgo psicosocial para los centros de trabajo que tengan entre 16 y 50 trabajadores, y de la identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional tratándose de centros de trabajo de más de 50 trabajadores (aplica para centros de trabajo de más de 15 trabajadores); y '
        },{
          'des':'-Las posibles alteraciones a la salud por la exposición a los factores de riesgo psicosocial.'
        },{
          'des':'La capacitación que esta Norma comprende está dirigida específicamente hacia directivos, gerentes y supervisores, y debe ser sobre la prevención de los factores de riesgo psicosocial y la promoción de entornos organizacionales favorables.'
        }
      ]
    },{
      pregunta: '¿Cuáles serán las sanciones por incumplimiento de la NOM-035-STPS-2018?',
      descripcion: [
        {
          'des':'Las sanciones por el incumplimiento se detallan en el Título Noveno, Sanciones Administrativas, del Reglamento Federal de Seguridad y Salud en el Trabajo.'
        },{
          'des':'Un ejemplo de ello:'
        },{
          'des':'Las empresas que incumplan (la norma) se podrán hacer acreedoras a una sanción por el equivalente de 50 a 5 mil veces la Unidad de Medida y Actualización (UMA) por cada obligación incumplida. El Inegi establece que una UMA tiene valor de 84.49 pesos. Por tanto, las multas se colocan entre los 4 mil 224.50 pesos y los 422 mil 450 pesos. '
        }
      ]

    },{
      pregunta:'¿Existen otras sanciones adicionales a la pecuniaria?',
      descripcion: [
        {
          'des':'Con base en lo dispuesto en el Reglamento Federal de Salud y Seguridad en el Trabajo por reincidencia puede resultar en clausura parcial o total de las actividades del centro de trabajo.'
        }
      ]

    }
  ]
  Seccion4 = [
    {
      pregunta:'¿En caso de que en un mismo centro de trabajo existan varias razones sociales se hace un estudio o varios estudios?',
      descripcion: [
        {
          'des':'Cada razón social es una organización diferente y tiene un registro patronal individual, por ello es necesario hacer un análisis independiente, como si no compartieran el espacio físico.'
        }
      ]
    },{
      pregunta:'¿Las respuestas de los trabajadores son privadas, confidenciales o anónimas?',
      descripcion: [
        {
          'des':'La información tendrá un manejo privado y confidencial, pero no es anónima. Es necesario el seguimiento puntual de los aspectos de la Norma.'
        },
        {
          'des':'Además del seguimiento o acciones para validar entorno social favorable, es necesario identificar a las personas que hayan sufrido algún acontecimiento traumático severo o que arrojen valoraciones altas en los factores de riesgo psicosocial, con el fin de recibir apoyo personalizado'
        },{
          'des':'El depositario de la confidencialidad de esta información es el encargado de cada centro de trabajo, y por consecuencia, su jefe directo (o la empresa). Te recordamos la divulgación de información confidencial puede ser constituida como un delito.'
        }
  
      ]
  
    },{
      pregunta:'¿Por qué el acoso sexual no está incluido en esta NOM-035?',
      descripcion: [
        {
          'des':'Del objetivo podemos distinguir que la NOM-035-STPS-2018, sólo comprende dos aspectos: los factores de riesgo psicosocial y el entorno organizacional favorable.'
        },
        {
          'des':'Además, en caso de existir el acoso sexual, la materia jurídica laboral, queda en un supeditada al tema penal.'
        }
  
      ]
  
    },{
      pregunta:'¿Qué método utilizará la Secretaría del Trabajo para elegir a qué organizaciones visitará para una inspección de la NOM-035?',
      descripcion: [
        {
          'des':'Un método aleatorio pero en el que considerará abarcar todas las regiones del país, a organizaciones de todos los sectores y de todos los tamaños.'
        },
        {
          'des':'También por medio de las denuncias de los trabajadores de una organización que reporte que no se ha implementado la NOM-035.'
        }
  
      ]
  
    }
  ]

  Seccion1Better = [
 
    {
      pregunta  : "¿Cuál es el contexto internacional alrededor de la NOM-035?",
      descripcion :[
        {
          'des':'La Organización Internacional del Trabajo señaló en 2013 un aumento en los nuevos tipos de enfermedades profesionales.',
        },{
          'des':'La OIT en 2016 señaló que el Centro de Trabajo es una fuente de importantes Riesgos Psicosociales y al mismo tiempo el lugar idóneo para tratarlos y proteger la salud de los trabajadores. '
        },{
          'des':'En el Plan Nacional de Desarrollo el gobierno mexicano 2013-2018 estableció el objetivo “Promover el empleo de calidad" y "Promover el trabajo digno o decente". '
        }
      ]
    },{
      pregunta  : "¿Qué es la NOM-035 explicada en pocas palabras?",
      descripcion :[
        {
          'des':'Es una regulación obligatoria que tiene como objetivo establecer los elementos para IDENTIFICAR, ANALIZAR Y PREVENIR  los Factores de Riesgo Psicosocial, así como para promover un Entorno Organizacional Favorable en los Centros de Trabajo.          ',
        },{
          'des':'Al mismo tiempo, es una regulación técnica que contiene información, especificaciones, procedimientos, instrumentos de medición y metodologías que deben cumplir todas las empresas en el país.'
        }
      ]
    },{
      pregunta  : "¿Cuáles son los 2 aspectos que es imprescindible conocer de la NOM-035?",
      descripcion :[
        {
          'des':'Que es:',
        },{
          'des':'1.- Obligatoria'
        },{
          'des':'2.- Insustituible'
        }
      ]
    },{
      pregunta  : "¿Qué relación tiene este NOM-035 con otras iniciativas como Wellness, Empresa Socialmente Responsable, Programas de Salud y Bienestar, Mindfulness, etc?",
      descripcion :[
        {
          'des':'Todos los esfuerzos que una organización haya realizado relacionados con Liderazgo, Wellness, Comunicación Efectiva, Organización del Trabajo, Programas de Integración, Modelos de Reconocimiento, así como las acreditaciones ó certificaciones de ESR, Great Place to Work, Súper Empresas, entre otros, pueden ser aprovechados si es que la empresa ya ha trabajado en ellos o planea hacerlo.',
        },{
          'des':'No obstante, dado que esta Norma es obligatoria e insustituible,  debe cumplirse utilizando su propia metodología.'
        }
      ]
    }

    


  ]
  Seccion2Better = [
    {
      pregunta  : "¿Cómo se calculan las multas que puede imponer la autoridad laboral en cada centro de trabajo?",
      descripcion :[
        {
          'des':'Debes referirte al Reglamento Federal de Seguridad y Salud en el Trabajo (RFSST) y considerar el cálculo que arroje cada uno de los puntos que se incumplan de acuerdo a lo que se indica en los siguientes artículos del Reglamento:',
        },{
          'des':'Artículo 115. Se impondrá multa de 50 a 100 veces el salario mínimo general diario vigente en el Distrito Federal, al patrón que no acredite, ni exhiba dentro del plazo que al efecto fije la Secretaría, de conformidad con las especificaciones dispuestas en las Normas, las documentales siguientes:'
        },{
          'des':'El Diagnóstico de Seguridad y Salud en el Trabajo, que comprenda los estudios y análisis de Riesgos requeridos por los artículos 7, fracción I; 19, fracción I; 20, fracción I; 22, fracción I; 24, fracción I; 25, fracción I; 26, fracciones I y II; 30, fracción I; 31, fracciones I y II; 36, fracción I; 39, fracción I; 40, fracción I; 41, fracción I; 42, fracción I; 43, fracciones I y II; 48, fracción I; 51, fracciones I y II; 53, fracción I; 54, fracción I, y 55, fracción III del presente Reglamento.'
        },{
          'des':'Artículo 117. Se impondrá multa de 250 a 5000 veces el salario mínimo general diario vigente en el Distrito Federal, al patrón que no acredite, ni exhiba dentro del plazo que al efecto fije la Secretaría, con base en las especificaciones que determinan las Normas, las documentales o testimoniales relacionados con:',
        },{
          'des':'I.	La difusión de información a los trabajadores requerida por los artículos 7, fracción XI; 18, fracción XIII; 20, fracción VII; 21, fracción XI; 22, fracción XVII; 23, fracción VIII; 29, fracción V; 30, fracción XII; 31, fracción XVI; 33, fracción VIII; 34, fracción VII; 35, fracción VII; 36, fracción XVI; 37, fracción VIII; 38, fracción VIII; 40, fracción VIII; 41, fracción X; 42, fracción IV; 43, fracción V; 45, fracción IX; 51, fracción IX; 53, fracción III; 54, fracción VIII, y 55, fracción V del presente Reglamento'
        },{
          'des':'Artículo 118. Se impondrá multa de 50 a 2000 veces el salario mínimo general diario vigente en el Distrito Federal, al patrón que no acredite, ni exhiba dentro del plazo que al efecto fije la Secretaría, de acuerdo con las especificaciones que disponen las Normas, las documentales relacionadas con:',
        },{
          'des':'II.	Los registros administrativos, por medios impresos o electrónicos, establecidos en los artículos 7, fracción XV; 18, fracción XIV; 19, fracción XVII; 20, fracción IX; 21, fracción XIII; 22, fracción XIX; 23, fracción X; 24, fracción XIII; 25, fracción XV; 26, fracción XVII; 29, fracción VII; 30, fracción XV; 31, fracción XIX; 33, fracción X; 34, fracción IX; 35, fracción VIII; 36, fracción XVIII; 37, fracción X; 38, fracción X; 39, fracciones VI y VII; 40, fracción X; 41, fracción XIII; 42, fracción VI; 43, fracción VI; 48, fracción VIII; 51, fracción XI; 53, fracción V; 54, fracción XI, y 55, fracción VI del presente Reglamento.'
        },{
          'des':'Artículo 119. Se impondrá multa de 50 a 3000 veces el salario mínimo general diario vigente en el Distrito Federal, al patrón que no acredite, ni exhiba dentro del plazo que al efecto fije la Secretaría, conforme a las especificaciones determinadas en las Normas, las documentales sobre los aspectos que a continuaciónse precisan:',
        },{
          'des':'La aplicación de los exámenes médicos al Personal Ocupacionalmente Expuesto, a que aluden los artículos 7, fracción IX; 21, fracción X; 23, fracciones IV y VII; 24, fracción X; 33, fracción VII; 34, fracción VI; 35, fracción VI; 36, fracción XV; 37, fracción VII; 38, fracción VII; 39, fracción IV; 40, fracción VII; 41, fracción IX; 42, fracción III, y 43, fracción IV del presente Reglamento.'
        },{
          'des':'Artículo 120. Se impondrá multa de 250 a 5000 veces el salario mínimo general diario vigente en el Distrito Federal, al patrón que no acredite, ni exhiba dentro del plazo que al efecto fije la Secretaría, con base en las especificaciones que señalan las Normas, el cumplimiento de las obligaciones que enseguida se citan:',
        },{
          'des':'La aplicación en la instalación de sus establecimientos de las medidas de Seguridad y Salud en el Trabajo previstas en los artículos 7, fracción VII; 18, fracciones I a III, V y VII a XII; 19, fracciones II, VIII a X y XII a XIV; 20, fracciones IV y V; 21, fracciones III a VII; 22, fracciones IV a XI y XIII a XV; 23, fracciones II, III y V; 24, fracciones V, VI y VIII; 25, fracciones VII a XI; 26, fracciones VI a XV; 29, fracciones I a IV; 30, fracciones IV a X; 31, fracciones VII y IX a XIV; 35, fracción II; 36, fracciones III, V a VII, IX a XI y XIII; 37, fracción III; 38, fracción III; 39, fracciones II y III; 41, fracciones IV y VIII; 42, fracción II; 43, fracción III; 51, fracciones III y VIII; 52, fracciones II y III; 53, fracción II; 54, fracciones III y VII, y 55, fracciones II y IV de este Reglamento y, las Normas, conforme a la naturaleza de las actividades y procesos laborales.'
        },{
          'des':'Artículo 125. Para la imposición de las sanciones señaladas en este Título, se tomará en cuentalo siguiente:',
        },{
          'des':'I.	El carácter intencional o no de la acción u omisión constitutiva de la infracción;'
        },{
          'des':'II.	La gravedad de la infracción, de acuerdo con el tipo de Riesgo que conlleva la omisión del cumplimiento de las obligaciones que determina este Reglamento y las Normas que correspondan;',
        },{
          'des':'III.	Los daños que se hubieren producido o puedan producirse;'
        },{
          'des':'IV.	La capacidad económica del infractor, y',
        },{
          'des':'V.	La reincidencia del infractor.'
        },{
          'des':'Para efectos de la fracción V, se entiende por reincidencia, cada una de las subsecuentes infracciones a un mismo precepto, cometidas dentro de los dos años siguientes a la fecha del acta en que se hizo constar la infracción precedente, siempre que ésta no hubiese sido desvirtuada.',
        }
      ]
    },{
      pregunta  : "¿A cuánto ascendería la multa de no cumplirse con ninguno de los puntos que se mencionan en cada uno de los artículos del RFFST?",
      descripcion :[
        {
          'des':'De no cumplirse ningún punto, la suma de todos los salarios mínimos es de 27,200. Considerando que en enero del 2020 el salario mínimo tiene el siguiente valor:',
        },{
          'des':'$123.22 pesos por jornada diaria de trabajo en todo el país, a excepción de la Zona Libre de la Frontera Norte (ZLFN), el monto de la multa sería de $3,351,584 pesos'
        },{
          'des':'$185.56 pesos por jornada diaria en la Zona Libre de la Frontera Norte (ZLFN), el monto de la multa sería de $5,047,232 pesos',
        },{
          'des':'Notas: '
        },{
          'des':'1.- Este cálculo se hace por centro de trabajo',
        },{
          'des':'2.- Es importante mencionar que para determinar el monto final de la multa la autoridad utiliza otros adicionales como la capacidad económica de la empresa y el tamaño de la empresa en cuanto a número de empleados y número de centros de trabajo'
        }
      ]
    },{
      pregunta  : "¿Existen otras sanciones adicionales a la multa económica?",
      descripcion :[
        {
          'des':'Con base en lo dispuesto en el Reglamento Federal de Salud y Seguridad en el Trabajo por reincidencia puede resultar en clausura parcial o total de las actividades del centro de trabajo.',
        }
      ]
    }
  ]
  Seccion3Better = [
    {
      pregunta  : "¿Por qué le llaman a esta Norma la Norma anti estrés? ¿esta NOM-035 va a medir el estrés?",
      descripcion :[
        {
          'des':'La falta de información ha dirigido la atención del público a uno de los temas más llamativos de la Norma, el estrés. Pero esta Norma lo que pretende es medir todos los agentes causales del estrés dentro del trabajo, así como de la depresión, ansiedad y alteraciones no orgánicas del ciclo sueño-vigilia.',
        }
      ]
    },{
      pregunta  : "Me siento confundido con tanta información que viene en la NOM-035, pues se repiten muchos términos y conceptos, parece como si fuera un rompecabezas. ¿Cómo puedo “armar” este rompecabezas?",
      descripcion :[
        {
          'des':'En una sola slide te mostramos todo lo que debes contemplar de manera ordenada. A este esquema lo hemos llamado: ',
        },{
          'des':'MODELO DE GESTIÓN DE RIESGOS PSICOSOCIALES DE LA NOM035'
        },{
          'des':'La mejor manera de leerlo es pensar como si fuera un plano cartesiano en donde:'
        },{
          'des':'el eje de las X muestra el tiempo en que debes cumplir las tareas '
        },{
          'des':'el eje de las Y muestras las actividades que debes resolver'
        }
      ]
    },{
      img: '1',
      pregunta  : "",
      descripcion :[
        
      ]
    },{
      img: '2',
      pregunta:"¿Qué relación existe entre los FRP y los síntomas y efectos en los trabajadores y la organización?",
      descripcion :[
        {
          'des':'',
        }
      ]
    },{
      pregunta  : "¿En caso de que en un mismo centro de trabajo existan varias razones sociales se hace un estudio o varios estudios?",
      descripcion :[
        {
          'des':'Cada razón social es una empresa diferente y tiene un registro patronal individual, por ello es necesario hacer un análisis independiente, como si no compartieran el espacio físico.',
        }
      ]
    },{
      pregunta  : "¿La información que responden los trabajadores es privada, confidencial o anónima?",
      descripcion :[
        {
          'des':'La información tendrá un manejo privado y confidencial, pero no puede ser anónima, debido a que es necesario, además de hacer un análisis transversal de todos los cuestionarios, también hacer evaluaciones de cada cuestionario para identificar a las personas que hayan sufrido algún acontecimiento traumático severo o que arrojen valoraciones altas en los factores de riesgo psicosocial, con el fin de recibir apoyo personalizado.',
        }
      ]
    },{
      pregunta  : "¿Si no es anónima, cómo se garantiza que no habrá represalias por parte de la empresa o de un supervisor?",
      descripcion :[
        {
          'des':'A través de una comunicación abierta y franca de parte de la Dirección General hacia los trabajadores previo al levantamiento de información en donde ofrezca el compromiso de hacer un manejo responsable de la información y garantice la privacidad y la confidencialidad.',
        }
      ]
    },{
      pregunta  : "¿Las personas de outsourcing deberán considerarse en el estudio?",
      descripcion :[
        {
          'des':'Sí, pues aunque el responsable principal del trabajador es un tercero, el subcontratista es responsable de asegurar las condiciones físicas y el ambiente donde realmente labora el trabajador. ',
        }
      ]
    },{
      pregunta  : "¿Qué ocurre con las personas que trabajan en la modalidad a distancia?",
      descripcion :[
        {
          'des':'También deben ser evaluadas en el estudio, pues aunque habrá algunas preguntas que no le apliquen, habrá otras que sí como la jornada de trabajo. ',
        },{
          'des':'En el análisis de los resultados se deberá reconocer si trabaja a distancia y, en general, se deberán interpretar las condiciones de cada persona como su ubicación y su actividad para que se apliquen las acciones correctivas que correspondan.'
        }
      ]
    },
  ]

  Seccion4Better = [
    {
      pregunta  : "¿Por qué es importante que el análisis final lo interprete alguien que conoce a fondo la compañía?",
      descripcion :[
        {
        'des':'Lo puede realizar un tercero que conozca los procesos productivos de la empresa, pero es conveniente que una persona interna valide los resultados al conocer a profundidad los por menores de la organización.',
        }
      ]
    },{
      pregunta  : "¿Hay que aplicar medidas correctivas con los análisis de los resultados?",
      descripcion :[
        {
          'des':'No. Es necesario previamente indagar para corroborar los resultados a través de entrevistas y conversaciones con los implicados. No olvidemos que responder las encuestas es un ejercicio de naturaleza subjetiva.',
        }
      ]
    },{
      pregunta  : "¿Cómo evaluar las condiciones físicas de trabajo en una empresa de transporte o logística en donde las personas primordialmente están fuera de una oficina?",
      descripcion :[
        {
          'des':'En esos casos, como en muchos otros, su centro de trabajo es “el trayecto” e incluye las condiciones de su trabajo, entre otras, de la unidad de transporte.',
        },{
          'des':'De cualquier manera, hay muchos otros temas que le aplican igual que a cualquier trabajador de otra industria, tales como: capacitación, jornada de trabajo, sentido de pertenencia, etc. Esos temas son independientes al lugar en donde se encuentre el trabajador.'
        }
      ]
    },{
      pregunta  : "¿Por qué el acoso sexual no está incluido en esta NOM-035?",
      descripcion :[
        {
          'des':'Debido al abordaje propio de la Norma, a la atención que este tema en particular requiere y por los aspectos legales que derivan del mismo. ',
        },{
          'des':'La materia laboral, en este caso, queda en un segundo plano en caso de llegar a un tema penal'
        }
      ]
    },{
      pregunta  : "¿Cómo evitas el riesgo de que los trabajadores utilicen esta NOM-035 para quejarse o pedir vacaciones?",
      descripcion :[
        {
          'des':'A través de una buena estrategia de comunicación, previo una profunda sensibilización de los directivos, jefes y supervisores de la empresa. ',
        }
      ]
    },{
      pregunta  : "¿Qué debo hacer si encuentro condiciones peligrosas en la empresa?",
      descripcion :[
        {
          'des':'Actuar inmediatamente y dar una solución que elimine o minimice el riesgo.',
        }
      ]
    },{
      pregunta  : "¿Qué método utilizará la Secretaría del Trabajo para elegir a qué empresas visitará para una inspección de la NOM-035?",
      descripcion :[
        {
          'des':'Un método aleatorio pero en el que considerará abarcar todas las regiones del país, a empresas de todos los sectores y de todos los tamaños.',
        },{
          'des':'También por medio de las denuncias de los trabajadores de una empresa que reporte que no se ha implementado la NOM-035.'
        }
      ]
    },{
      pregunta  : "¿Vale la pena esperar a implementar la NOM-035?",
      descripcion :[
        {
          'des':'No. Además de la importancia de cumplir con los plazos que se dieron, es un compromiso social del que debemos estar convencidos más que pensar que debemos hacerlo por obligación.',
        }
      ]
    }
    

  ]

}
